import { Department } from "../Department/Department.type";
import { Document } from "../Document/Document.type";
import { Material } from "../Material/Material.type";
import { Project } from "../Project/Project.type";
import { User } from "../User/User.type";
import { ApiCallState, PagedData } from "../Utils";

export type MaterialRequisition = {
  mr_number: string;
  requested_to: string;
  department_id?: number;
  project_id?: number;
  project?: Project;
  department?: Department;
  date: string;
  id: any;
  remark: string;
  is_planned: boolean;
  type: string;
  material_requisition_items: MaterialRequisitionItem[];
  material_requisition_documents: MaterialRequisitionDocument[];
  requested_by: string;
  mr_prepared_by: User | null;
  mr_checked_by: User | null;
  mr_approved_by: User | null;
  is_done: boolean;
  material_requisition_statuses: MaterialRequisitionStatus[];
  division_block?: string;
  purpose?: string;
  delivery_time?: string;
  pad_ref?: string;
  apartment_unit?: string;
  is_void?: boolean;
  user_id: number;
  ist_converted: boolean;
  approved_by?: number;
  authorized_by?: number;
  checked_by?: number;
  is_pmr?: boolean;
  is_draft?: boolean;
  pmr_id?: number;
};

export type MaterialRequisitionStatus = {
  material_requisition_id: number;
  type: "View" | "Check" | "Approve" | "Authorize";
  status: number;
  assigned_by: number;
  user_id: number;
  id: number;
};

export type MaterialRequisitionItem = {
  material: Material;
  quantity: number;
  additional_quantity: number;
  received: number;
  material_id: number;
  id: number;
  unit?: string;
};

export type MaterialRequisitionDocument = {
  id: number;
  material_requisition_id: number;
  document_id: number;
  description: string;
  document: Document;
};

export type MaterialRequisitionStateTypes = {
  fetchAll: ApiCallState<MaterialRequisition[]>;
  fetchOne: ApiCallState<MaterialRequisition | {}>;
  fetchPaged: ApiCallState<PagedData<MaterialRequisition[]>>;
};

export const MaterialRequisitionActionTypes = {
  FETCH_ALL_MATERIAL_REQUISITION: "FETCH_ALL_MATERIAL_REQUISITION",
  FETCH_ALL_MATERIAL_REQUISITION_RESET: "FETCH_ALL_MATERIAL_REQUISITION_RESET",
  FETCH_ALL_MATERIAL_REQUISITION_FAILURE:
    "FETCH_ALL_MATERIAL_REQUISITION_FAILURE",
  FETCH_ALL_MATERIAL_REQUISITION_SUCCESS:
    "FETCH_ALL_MATERIAL_REQUISITION_SUCCESS",

  FETCH_ONE_MATERIAL_REQUISITION: "FETCH_ONE_MATERIAL_REQUISITION",
  FETCH_ONE_MATERIAL_REQUISITION_RESET: "FETCH_ONE_MATERIAL_REQUISITION_RESET",
  FETCH_ONE_MATERIAL_REQUISITION_FAILURE:
    "FETCH_ONE_MATERIAL_REQUISITION_FAILURE",
  FETCH_ONE_MATERIAL_REQUISITION_SUCCESS:
    "FETCH_ONE_MATERIAL_REQUISITION_SUCCESS",

  FETCH_PAGED_MATERIAL_REQUISITION: "FETCH_PAGED_MATERIAL_REQUISITION",
  FETCH_PAGED_MATERIAL_REQUISITION_RESET:
    "FETCH_PAGED_MATERIAL_REQUISITION_RESET",
  FETCH_PAGED_MATERIAL_REQUISITION_FAILURE:
    "FETCH_PAGED_MATERIAL_REQUISITION_FAILURE",
  FETCH_PAGED_MATERIAL_REQUISITION_SUCCESS:
    "FETCH_PAGED_MATERIAL_REQUISITION_SUCCESS",
};
